import { render, staticRenderFns } from "./TermosdeUso.vue?vue&type=template&id=1742be3e&scoped=true&"
import script from "./TermosdeUso.vue?vue&type=script&lang=js&"
export * from "./TermosdeUso.vue?vue&type=script&lang=js&"
import style0 from "./TermosdeUso.vue?vue&type=style&index=0&id=1742be3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742be3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCheckbox,VForm})
